import { render, staticRenderFns } from "./TeacherCamera.vue?vue&type=template&id=1da17946&scoped=true"
import script from "./TeacherCamera.vue?vue&type=script&lang=js"
export * from "./TeacherCamera.vue?vue&type=script&lang=js"
import style0 from "./TeacherCamera.vue?vue&type=style&index=0&id=1da17946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da17946",
  null
  
)

export default component.exports